import React from 'react';
import { Bar } from 'react-chartjs-2';
import { View } from "react-native-web";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const ScoreChart = ({ data }) => {
  const formatDate = (date) => {
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    const d = new Date(date);
    const dayOfWeek = days[d.getDay()];
    const dayOfMonth = d.getDate();
    const month = months[d.getMonth()];

    const suffix = (dayOfMonth % 10 === 1 && dayOfMonth !== 11) ? 'st' :
                   (dayOfMonth % 10 === 2 && dayOfMonth !== 12) ? 'nd' :
                   (dayOfMonth % 10 === 3 && dayOfMonth !== 13) ? 'rd' : 'th';

    return `${dayOfWeek} ${dayOfMonth}${suffix} ${month}`;
  };

  const parseData = (lengthKey) => {
    return data[lengthKey].map((entry) => ({
      x: formatDate(entry.date),
      y: entry.score,
    }));
  };

  const chartData = {
    labels: [...new Set([
      ...data['4'].map((entry) => formatDate(entry.date)),
      ...data['5'].map((entry) => formatDate(entry.date)),
      ...data['6'].map((entry) => formatDate(entry.date))
    ])],
    datasets: [
      {
        label: '4-Letter Words',
        data: parseData('4').map((entry) => entry.y),
        backgroundColor: "#8e44ad",
        barThickness: 5,
        maxBarThickness: 20,
      },
      {
        label: '5-Letter Words',
        data: parseData('5').map((entry) => entry.y),
        backgroundColor: "#e67e22",
        barThickness: 5,
        maxBarThickness: 20,
      },
      {
        label: '6-Letter Words',
        data: parseData('6').map((entry) => entry.y),
        backgroundColor: "#3498db",
        barThickness: 5,
        maxBarThickness: 20,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        type: 'category',
        title: {
          display: true,
          text: 'Date',
        },
        categoryPercentage: 0.6, // Reserve 60% of the space for bars, leaving 40% for gaps
        barPercentage: 0.7,      // Use 70% of the reserved space for each bar
      },
      y: {
        title: {
          display: true,
          text: 'Score',
        },
        min: 0,
        max: 100,
      },
    },
    plugins: {
      legend: {
        position: 'top',
      },
      tooltip: {
        callbacks: {
          label: (context) => `Score: ${context.raw}`,
        },
      },
    },
  };

  return (
    <View style={{ width: '100%', height: '400px' }}>
      <Bar data={chartData} options={options} />
    </View>
  );
};

export default ScoreChart;
